/**
 * 判断是不是邮箱地址
 */
export function validEmail(str: string, validEmpty?: boolean): boolean {
  if (validEmpty && str === '') return true;
  const reg = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  return reg.test(String(str));
}

/**
 * 判断是不是手机号
 */
export function validPhoneNumber(str: string, validEmpty?: boolean): boolean {
  if (validEmpty && str === '') return true;
  const reg = /^[0-9]*$/;
  return reg.test(String(str));
}

export const getPhoneNumber = (phone: string): { area: string; phone: string } => {
  const phoneArr = phone?.split('-');
  if (phoneArr.length === 2) {
    return {
      area: phoneArr[0],
      phone: phoneArr[1],
    };
  }
  return {
    area: '',
    phone,
  };
};
